import { InformationCircleIcon } from "@heroicons/react/24/outline";
import Input from "src/components/inputs/Input";
import SensitiveTextarea from "src/components/inputs/SensitiveTextarea";

interface PauboxConfigTabProps {
  apiKey: string;
  onApiKeyChange: (value: string) => void;
  baseUrl: string;
  onBaseUrlChange: (value: string) => void;
  emailAddress: string;
  onEmailAddressChange: (value: string) => void;
  disableInputs: boolean;
}

const PauboxConfigTab = ({
  apiKey,
  onApiKeyChange,
  baseUrl,
  onBaseUrlChange,
  emailAddress,
  onEmailAddressChange,
  disableInputs,
}: PauboxConfigTabProps) => (
  <>
    <h3 className="text-lg font-medium text-gray-900">Paubox</h3>
    <div className="mt-2 flex gap-3 rounded-lg border border-blue-200 bg-blue-50 px-4 py-3">
      <InformationCircleIcon className="h-5 w-5 shrink-0 text-blue-700" aria-hidden />
      <p className="text-sm text-blue-700">
        Required for onboarding users. Configure Paubox to send invite and verification emails.
      </p>
    </div>
    <div className="mt-4 space-y-4">
      <SensitiveTextarea
        label="API Key"
        placeholder="Enter Paubox API Key"
        value={apiKey}
        onChange={onApiKeyChange}
        required={false}
        disabled={disableInputs}
      />
      <Input
        type="text"
        label="Base URL"
        placeholder="Enter Paubox Base URL"
        value={baseUrl}
        onChange={(e) => onBaseUrlChange(e.target.value)}
        required={false}
        disabled={disableInputs}
      />
      <Input
        type="email"
        label="Email Address"
        placeholder="Enter From Email Address"
        value={emailAddress}
        onChange={(e) => onEmailAddressChange(e.target.value)}
        required={false}
        disabled={disableInputs}
      />
    </div>
  </>
);

export default PauboxConfigTab;
